import { render, staticRenderFns } from "./CreateRoleComponent.vue?vue&type=template&id=f675425e"
import script from "./CreateRoleComponent.vue?vue&type=script&lang=js"
export * from "./CreateRoleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports